import { EntertainmentVideoStatus } from './types';

export const ENTERTAINMENT_VIDEO_STATUS_TO_STATUS_LABEL_TYPE = {
  [EntertainmentVideoStatus.DRAFT]: 'draft',
  [EntertainmentVideoStatus.PENDING]: 'warning',
  [EntertainmentVideoStatus.DECLINED]: 'danger',
  [EntertainmentVideoStatus.PUBLISH_FAILED]: 'danger',
  [EntertainmentVideoStatus.PUBLISHING]: 'warning',
  [EntertainmentVideoStatus.PUBLISHED]: 'success',
  [EntertainmentVideoStatus.UNPUBLISH_FAILED]: 'danger',
  [EntertainmentVideoStatus.UNPUBLISHING]: 'warning',
  [EntertainmentVideoStatus.UNPUBLISHED]: 'warning'
} as const;

/**
 * Ideally this list should be in sync with backend:
 * https://github.bus.zalan.do/Team-Collab/collab-backend/blob/8a3d8ff777165b521134aa85a37c0a1c2e23482f/collab-backend-api/src/main/java/com/collabary/common/utils/SupportedImageContentTypes.java
 */
export const ENTERTAINMENT_VIDEO_SUPPORTED_FILE_TYPES = [
  'video/3gpp',
  'video/3gpp2',
  'video/x-msvideo',
  'video/mp4',
  'video/quicktime',
  'video/ogg',
  'video/webm',
  'video/x-flv',
  'video/x-ms-wmv',
  'video/mpeg',
  'video/avi'
];

/**
 * Runtime config fallback values
 */
export const ENTERTAINMENT_VIDEO_MAX_FILE_SIZE_FALLBACK = 614572800; // bytes
export const ENTERTAINMENT_VIDEO_MAX_DURATION_FALLBACK = 300; // seconds

export const PUBLISHED_DATES_FORMAT = 'YYYY-MM-DD';

export const GENDERS = ['women', 'men', 'kids'];
